import React, { useMemo } from "react";
import moment from "moment";
import { Button, Card, Table } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { usePagination } from "ahooks";
import { ColumnsType } from "antd/lib/table";
import { getSharedEwaybillShippingAddressRechargeRecords } from "@/services/api/sharedEwaybillShippingAddress";

interface SharedRechargeRecordsProps {}

function useColumns(consumerName: string, consumerCompanyName: string): ColumnsType<any> {
  return [
    {
      title: "序号",
      key: "index",
      render: (value, record, index) => {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: "时间",
      dataIndex: "dateCreated",
      render: (dateCreated) => {
        if (!dateCreated) {
          return null;
        }
        return <div>{moment(dateCreated).format("YYYY-MM-DD HH:mm:ss")}</div>;
      },
    },
    {
      title: "操作类型",
      key: "type",
      dataIndex: "quantity",
      render: (quantity, record, index) => {
        return <div>{quantity >= 0 ? "增加" : "减少"}</div>;
      },
    },
    {
      title: "数量",
      dataIndex: "quantity",
      render: (quantity, record, index) => {
        return <div>{Math.abs(quantity)}</div>;
      },
    },
    {
      title: "使用面单的人",
      key: "consumerCompanyName",
      width: 150,
      render: (_, record) => {
        return (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            {consumerName ? (
              <div>
                <span className="fw700">{consumerName}</span>
              </div>
            ) : null}

            {consumerCompanyName ? <div className={"attentionColor"}>微信：{consumerCompanyName}</div> : null}
          </div>
        );
      },
    },
  ];
}

/**
 * 查询充值记录页面
 */
const SharedRechargeRecords: React.FC<SharedRechargeRecordsProps> = function (props) {
  const history = useHistory();
  const params = useParams();

  const id = params["id"];

  const extraInfo = useMemo(() => {
    try {
      const search = new URLSearchParams(history.location.search);

      const infoString = search.get("extraInfo");

      const obj = JSON.parse(infoString);

      const title = obj.title;
      // 备注
      const consumerName = obj.consumerName;
      // 微信
      const consumerCompanyName = obj.consumerCompanyName || obj.providerCompanyName;

      return {
        title,
        consumerName,
        consumerCompanyName,
      };
    } catch (error) {
      return {};
    }
  }, []);

  const columns = useColumns(extraInfo.consumerName, extraInfo.consumerCompanyName);

  const { data, pagination, loading } = usePagination(async ({ current, pageSize }) => {
    const result = await getSharedEwaybillShippingAddressRechargeRecords(id, current, pageSize);

    return {
      list: result.content,
      total: result.totalElements,
    };
  });

  return (
    <Card>
      <div
        style={{
          fontWeight: 400,
          fontSize: "18px",
          lineHeight: "18px",
          padding: "10px 5px",
          borderRadius: "5px",
        }}
      >
        <Button
          type="link"
          className={"ml15"}
          onClick={() => {
            history.goBack();
          }}
        >
          {"<返回"}
        </Button>

        <span>充值记录： {decodeURIComponent(extraInfo.title)}</span>
      </div>

      <Table
        rowKey="id"
        size="small"
        columns={columns}
        dataSource={data?.list}
        loading={loading}
        pagination={{
          ...pagination,
          showQuickJumper: true,
          showTotal: (total) => `总共 ${total} 个项目`,
          showSizeChanger: true,
          pageSizeOptions: ["10", "50", "100", "200"],
        }}
      />
    </Card>
  );
};

export default React.memo(SharedRechargeRecords);
